export default __webpack_public_path__ + "static/media/Group 8197.ce7df8d9.png";